export class RetrievalModelRequest {
    public model: string | null = null
    public input: string | null = null
    public input_type: string | null = null
    public encoding_format: string | null = null
}
